// extracted by mini-css-extract-plugin
module.exports = {"headline":"NoRange_headline__3kvhf"};